import api from '@/services/api/api';

export const useAuthorBySlug = (slug) => {
  const authorSlug = useQuery(
    ['authorSlug', slug],
    async () => {
      const { data } = await api.authors.getAuthorBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await authorSlug.suspense();
  });

  return {
    authorSlug,
  };
};
